import { format } from "date-fns";

export function formatDatetime(date: Date | string) {
  const dateObject = typeof date === "string" ? new Date(date) : date;

  return format(dateObject, "dd LLL yyyy, HH:mm:ss");
}
